/*eslint-disable */

import { useState, useEffect, useContext } from 'react';
import ListHeader from '../SectionHeader';
import TablePagination from '../TablePaginationComponent';
import useFetchData from '../../hooks/useFetchData';
import useSort from '../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../assets/images/sort.svg';
import Filter from '../Filter';
import { useNavigate } from 'react-router-dom';
import GlobalContext from 'contexts';

import globalTranslating from '../../translate.json';
import ClientTranslate from './translate.json';
import ExcelDownload from 'components/ExcelDownload';
// import '../style.scss';

const AnalysisQuestions = () => {
  const navigate = useNavigate();
  const translating = { ...globalTranslating, ...ClientTranslate };
  const [filteredclients, setFilteredclients] = useState([]);
  const [questionsList, setQuestionsList] = useState([]);
  const { data, loading } = useFetchData(
    'client-product/dashboard/geneticAnalysisQuestions'
  );

  useEffect(() => {
    if (data?.data?.length) setFilteredclients(data.data);
    if (data?.questions?.length) setQuestionsList(data?.questions);
  }, [data]);

  const onFilter = (filteredData) => {
    setFilteredclients(filteredData);
  };

  const onResetFilters = () => {
    setFilteredclients(clientsData);
  };

  const { showFilters, toggle } = useSort();

  const actionsclientsList = [
    {
      icon: SortIcon,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredclients(clientsData);
        toggle(!showFilters);
      }
    }
  ];

  const tableHeaders = [
    translating.clientId,
    translating.fullName,
    translating.barcode,
    translating.ssn
    // translating.createdDate
  ];

  questionsList?.forEach((element) => {
    tableHeaders.push(element.text);
  });

  const [columns, setColumns] = useState([
    { value: 'id' },
    { value: 'clientFullName', sort: true, bold: true },
    { value: 'barcode' },
    { value: 'ssn' }
    // { value: 'createdAt', format: 'date' }
  ]);

  useEffect(() => {
    const newColumns = [...columns];
    questionsList?.forEach((element) => {
      newColumns.push({ value: element.text.replace('"', '') });
    });
    setColumns(newColumns);
  }, [questionsList]);

  return (
    <div className="customers-list">
      <ListHeader
        title={translating.analysisQuestions}
        actions={actionsclientsList}
      ></ListHeader>
      {/* {showFilters && productsList && (
        <Filter
          fields={sortFields}
          data={clientsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )} */}
      <div className="customers-list-wrapper-table">
        {loading && <div>Loading</div>}
        {filteredclients?.length ? (
          <ExcelDownload
            data={filteredclients}
            filename={'ניתוח שאלונים.csv'}
          ></ExcelDownload>
        ) : null}
        {filteredclients && !loading && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredclients}
            pagination={true}
          ></TablePagination>
        )}
      </div>
    </div>
  );
};

export default AnalysisQuestions;
